import { toast, ToastOptions } from 'react-toastify';
import { SystemToast } from '../components/toasts/systemMessageToast';
import styles from '../components/toasts/systemMessageToast.module.scss';

type SystemMessagingContent = {
    message: string;
    subMessage?: string;
};

const toastOptions: ToastOptions = {
    position: 'bottom-center',
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    hideProgressBar: true,
    className: styles.systemMessageToast,
    closeButton: false,
};

export class SystemMessaging {
    private static instance?: SystemMessaging;

    static getInstance() {
        if (!SystemMessaging.instance) {
            SystemMessaging.instance = new SystemMessaging();
        }
        return SystemMessaging.instance;
    }

    static success(content: SystemMessagingContent) {
        return SystemMessaging.getInstance().success(content);
    }

    static error(content: SystemMessagingContent) {
        return SystemMessaging.getInstance().error(content);
    }

    success(content: SystemMessagingContent) {
        return toast(<SystemToast message={content.message} type="success" />, toastOptions);
    }

    error(content: SystemMessagingContent) {
        return toast(<SystemToast message={content.message} subMessage={content.subMessage} type="error" />, toastOptions);
    }
}
